import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import router from '@/router';
import Big from 'big.js';

/**
 * @desc 时间格式化
 * @param  {Date} time timestarmp 两种数据类型
 * @param  {String} cFormat 需转换的格式
 * @returns {*}
 */

export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;

  if (typeof time === 'object') {
    date = time;
  } else if ((String(time)).length === 13) {
    let timestamp = Number(time);
    date = new Date(timestamp);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];

    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });

  return timeStr;
}

/**
 * 是否是外链接
 * @param  {String} path 链接地址
 * @returns {boolean}
 */
export function isExternal (path) {
  return /^(http?:|https?:|mailto:|tel:)/.test(path);
}

/**
 * @desc 精确加法
 * @param {number} a 加数1
 * @param {number} b 加数2
 * @returns {number}
 */
export function MathAdd (a, b) {
  let r1, r2, m;
  if (typeof a === 'number') {
    a = a.toString();
  }
  if (typeof b === 'number') {
    b = b.toString();
  }
  try {
    r1 = a.split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = b.split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (a * m + b * m) / m;
}

/**
 * @desc 减法函数
 * @param {number} arg1 减数1
 * @param {number} arg2 减数2
 * @returns {number}
 */
export function Subtr (arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  // last modify by deeka
  // 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

/**
 * @desc 精确乘法
 * @param {number} arg1 乘数1
 * @param {number} arg2 乘数2
 * @returns {number}
 */
export function MathMulti (arg1, arg2) {
  let m = 0;
  arg2 = arg2 || 0;
  let s1 = arg1.toString();
  let s2 = arg2.toString();

  try { m += s1.split('.')[1].length; } catch (e) { }

  try { m += s2.split('.')[1].length; } catch (e) { }

  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

/**
 * @desc 精确除法
 * @param {number} num1 被除数
 * @param {number} num2 除数
 * @returns {number}
 */
export function numDiv (num1, num2) {
  let baseNum1 = 0;
  let baseNum2 = 0;
  let baseNum3, baseNum4;
  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }

  baseNum3 = Number(num1.toString().replace('.', ''));
  baseNum4 = Number(num2.toString().replace('.', ''));
  return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1);
};

/**
 * @desc 数字金额转大写
 * @param {number} n 数字金额
 * @returns {String}
 */
export function smalltoBIG (n) {
  let fraction = ['角', '分'];
  let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  let unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
  let head = n < 0 ? '欠' : '';
  n = Math.abs(n);

  let s = '';

  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  n = Math.floor(n);

  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
}

/**
 * @desc 把日期转换为字符串形式
 * @param   {Date} date 日期
 * @returns {String} 'yyyy-MM-dd'
 */
export function DateToStr (date) {
  let year = date.getFullYear();
  let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
  let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  return year + '-' + month + '-' + day;
}

/**
 * @desc 把日期转换为指定字符串形式
 * @param {Date} date 日期
 * @param {String} fmt 返回格式
 * @returns {String}
 */
export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};

/**
 * @desc 字符串左侧添加'00'
 * @param {String} str 需添加的字符串
 * @returns {String}
 */
function padLeftZero (str) {
  return ('00' + str).substr(str.length);
}

/**
 * @desc 加法运算
 * @param {number} num1 加数1
 * @param {number} num2 加数2
 * @author motioliang
 */
export function numAdd (num1, num2) {
  var baseNum, baseNum1, baseNum2, c;
  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  c = Math.abs(baseNum1 - baseNum2);
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (baseNum1 > baseNum2) {
      num1 = Number(num1.toString().replace('.', ''));
      num2 = Number(num2.toString().replace('.', '')) * cm;
    } else {
      num1 = Number(num1.toString().replace('.', '')) * cm;
      num2 = Number(num2.toString().replace('.', ''));
    }
  } else {
    num1 = Number(num1.toString().replace('.', ''));
    num2 = Number(num2.toString().replace('.', ''));
  }
  return (num1 + num2) / baseNum;
}

/**
 * @desc 下载流文件
 * @param {blob} content 流文件
 * @param {string} type 文件类型, 默认值 text/plain
 * @param {string} fileName 文件名称，默认值 test.text
 */
export function downloadBlobFile ({ content, type = 'text/plain', fileName = 'test.text' }) {
  let blob = new Blob([content], { type });
  saveAs(blob, fileName);
}

/**
 * @desc 下载文件
 * @param {string} url 文件地址
 * @param {string} fileName 文件名称
 */
export function downloadUrlFile (url, fileName) {
  let ele = document.createElement('a');
  ele.style.display = 'none';
  ele.setAttribute('href', url);
  if (fileName) ele.setAttribute('download', fileName);
  document.body.appendChild(ele);
  ele.click();
  ele.remove();
}

/**
 * @desc 设置维护界面
 * @param {string} benginTime 开始时间
 * @param {string} endTime 结束时间
 * @param {string} env 运行环境，默认 pro
 * @param {string} path 运维界面路由，默认 /shutDown
 */
export function setMaintainPage ({ benginTime, endTime, env = 'pro', path = '/shutDown' }) {
  if (window._env_.NODE_ENV !== env) return;
  if (dayjs().isAfter(dayjs(benginTime)) && dayjs().isBefore(dayjs(endTime))) {
    // if (localStorage.getItem('whatName') !== 'BibalaZhaojingzhong') {
    router.push({ path });
    // }
  }
}

/**
 * @param blob 文件流
 * @returns {Promise<unknown>}
 */

export const readErrorBlob = (blob) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsText(blob, 'utf-8');
    fileReader.addEventListener('loadend', () => {
      let result = null;
      try {
        result = JSON.parse(fileReader.result);
      } catch (e) {
        reject(e);
      }
      if (result) {
        resolve(result);
      }
    });
  });
};
// 处理特殊字符
export function handleInputRule (val) {
  // return val.replace(/[`~!@#$%^&*_\\+=<>?:{}|,./;\\[\]·~！@#￥%……&*——\\+={}|《》？：【】、；，。、]/g, '');
  return val;
}

/**
 * @desc 转换成 number
 * @param {any}
 * @returns {number}
 */
export function getNum (value) {
  return Number(value || 0) || 0;
}

/**
 * @desc 数值进行，小数位置取值
 * @param {any} value
 * @param {number} precision  小数精度， 默认2位
 * @returns {string}
 */
export function numToFixed (value, precision = 2) {
  return Big(getNum(value)).toFixed(getNum(precision));
}

/**
 * @description 检测字符中是否有特殊字符
 * @param str
 * @returns {boolean}
 */
export const checkSpecialCharacters = (str) => {
  // 规则对象(flag)
  let flag = new RegExp("[`~!@#$^&*=|{}':;',\\[\\]<>《》/?~！@#￥……&*|{}【】‘；：”“'。，、？ ]");
  // 判断 even 是否包含特殊字符
  return flag.test(str);
};

/**
 * @description 深拷贝数据
 * @param data
 * @returns {{}|number|string|Date|*[]|*|boolean}
 */
export function deepCopy (data) {
  // string,number,bool,null,undefined,symbol
  // object,array,date
  if (data && typeof data === 'object') {
    // 针对函数的拷贝
    if (typeof data === 'function') {
      let tempFunc = data.bind(null);
      tempFunc.prototype = deepCopy(data.prototype);
      return tempFunc;
    }

    switch (Object.prototype.toString.call(data)) {
      case '[object String]':
        return data.toString();
      case '[object Number]':
        return Number(data.toString());
      case '[object Boolean]':
        return Boolean(data.toString());
      case '[object Date]':
        return new Date(data.getTime());
      case '[object Array]':
        var arr = [];
        for (let i = 0; i < data.length; i++) {
          arr[i] = deepCopy(data[i]);
        }
        return arr;

      // js自带对象或用户自定义类实例
      case '[object Object]':
        var obj = {};
        for (let key in data) {
          // 会遍历原型链上的属性方法，可以用hasOwnProperty来控制 （obj.hasOwnProperty(prop)
          obj[key] = deepCopy(data[key]);
        }
        return obj;
    }
  } else {
    // string,number,bool,null,undefined,symbol
    return data;
  }
}

/**
 * @desc 函数防抖
 * @param {function} func 函数
 * @param {number} wait 延迟执行毫秒数
 * @param {boolean} immediate true 表立即执行，false 表非立即执行
 */
export function debounce (func, wait = 800, immediate = false) {
  let timeout;

  return function () {
    let context = this;
    let args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(() => {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  };
}

/**
 * @desc 跳转停机维护界面
 * @param {string} startTimeStr 开始时间
 * @param {string} endTimeStr   结束时间
 * @param {string} message      描述
 */
export function jumpShutDownPage ({ startTimeStr, endTimeStr, message }) {
  let path = `${window.location.origin}/shutDown`;
  location.href = `${path}?startTime=${startTimeStr}&endTime=${endTimeStr}&msg=${message}`;
}

/**
 * 格式化显示数据
 * @param {Object} row 行数据
 * @param {Object} column 列配置信息
 * @param {string | number} cellValue 当前单元格
 * @param {number} index 索引
 * @param {"date"|"dateTime"|"yesOrNo"|"number"} [type] 类型
 * @return {string|number}
 */
export function formatterValue (row, column, cellValue, index, type) {
  switch (type) {
    case 'date':
      return cellValue ? dayjs(cellValue).format('YYYY-MM-DD') : '-';
    case 'dateTime':
      return cellValue ? dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss') : '-';
    case 'yesOrNo':
      return cellValue ? '是' : '否';
    case 'number':
      return cellValue || cellValue === 0
        ? Big(getNum(cellValue)).toFixed(2)
        : '-';
    default:
      return cellValue || '-';
  }
}
